import { render } from "./ClientRequestsTable.vue?vue&type=template&id=b63900ea"
import script from "./ClientRequestsTable.vue?vue&type=script&lang=js"
export * from "./ClientRequestsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__